import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from '../text/Text';

type NativeH1Props = React.ComponentPropsWithoutRef<'h1'>;

export type H1Props = Omit<TextProps, 'tag'> & { tag?: 'h1' } & NativeH1Props;

const BaseH1: React.FC<H1Props> = ({ children, tag, ...otherProps }) => (
    <Text h1 tag="h1" {...otherProps}>
        {children}
    </Text>
);

const H1 = styled(BaseH1)`
    line-height: ${({ theme }) => theme.lineHeights.title};
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

H1.displayName = 'H1';
export default H1;
